import axios from 'axios';
import Constants from 'src/constants';
import { backendUrl } from 'src/app-globals';

export const passwordreset = {
    namespaced: true,
    state: {
        linkActiveId: {},
        externalId: '',
    },
    getters: {
        getLinkActiveId (state) {
            return state.linkActiveId;
        },
        getExternalId (state) {
            return state.externalId;
        },
    },
    mutations: {
        setLinkActiveId (state, data) {
            state.linkActiveId = data;
        },
        setExternalId (state, id) {
            state.externalId = id;
        },
        clearOffLinkActiveId (state) {
            state.linkActiveId = {};
        },
        clearOffExternalId (state) {
            state.externalId = '';
        },
    },
    actions: {
        async resetPassword ({ dispatch }, payload) {
            const url = `${backendUrl}/api/user-update/password/reset`;
            try {
                await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in resetting your password.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async createLinkActiveId ({ dispatch, commit }, payload) {
            const url = `${backendUrl}/api/user-update/check`;
            try {
                const response = await axios.post(url, payload);
                commit('setLinkActiveId', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in resetting your password.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        storeExternalId (context, id) {
            context.commit('setExternalId', id);
        },
        async createNewPassword ({ dispatch }, payload) {
            const url = `${backendUrl}/api/user-update/password/update`;
            try {
                await axios.put(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your new password.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        clearLinkActiveId ({ commit }) {
            commit('clearOffLinkActiveId');
        },
        clearExternalId ({ commit }) {
            commit('clearOffExternalId');
        },
    },
};
